import styled, { keyframes } from 'styled-components';

const rotationAnimation = keyframes `
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
`;
const StyledSpinner = styled.div `
  border: 6px solid ${props => `${props.theme.colors.darkGray}1A`};
  border-top: 6px solid ${props => props.theme.colors.skyBlue};
  border-radius: 50%;
  width: ${props => props.size};
  height: ${props => props.size};
  animation: ${rotationAnimation};
  animation-duration: ${props => props.theme.animation.duration.long};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
`;

export { StyledSpinner };
//# sourceMappingURL=Spinner.styles.mjs.map
